import styled, { css } from "styled-components";

const fontStyles = css`
  font-family: "Lato";
  line-height: 1;
  font-size: 1rem;
`;
export const FormBody = styled.div`
  max-height: 60vh;
  padding: 0 1.375rem;
  overflow-y: auto;
`;
export const OptionsWrapper = styled.div`
  padding: 1.375rem;
`;
export const FlexRow = styled.div`
  display: flex;
  align-items: ${(props) => props.align ?? "center"};
  > div {
    margin-right: 1rem;
  }
`;

export const SectionContainer = styled.section`
  width: 100%;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 1.25rem;
`;

export const AnalyticalInfoWrapper = styled.div`
  padding: 1.375rem;
  max-height: 60vh;
  overflow-y: auto;
`;

export const AnalyticalInfoText = styled.div`
  font-family: Lato;
  font-size: 16px;
  display: flex;
  align-items: center;
`;

export const AnalyticalTitleText = styled.h2`
  color: #1bace4;
  font-size: 16px;
  font-family: lato;
  text-transform: initial;
  margin-bottom: 10px;
  line-height: 1;
  margin-top: -3px;
  font-weight: bold;
`;

export const AnalyticalTitleValue = styled.div`
  color: #767676;
  margin: 0;
  line-height: 1;
  font-size: 16px;
  padding-left: 10px;
`;
export const AnalyticalWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  font-weight: bold;
`;

export const WrapperStatus = styled.div`
  justify-self: end;
`;

export const DocumentRow = styled.div`
  padding-left: 1rem;
  margin-bottom: 0.2rem;
  font-size: 14px !important;
`;

export const DocumentInfo = styled.div`
  display: grid;
  grid-template-columns: 25.3rem 14.2rem 0rem;
  text-color: #084987 !important;
  gap: 1.25rem;
  margin: 0;
`;

export const DocumentWrppaer = styled.div`
  margin-top: 20px;
  margin-bottom: 10px;
`;

export const DocumentName = styled.a`
  position: relative;
  font-size: 14px;
  line-height: 16px;
  color: #1bace4 !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none !important;
  cursor: pointer;
  text-transform: initial;
  margin: 0;
`;
